import { trendingCategories } from '@/mocks/categories';

export default function TrendingSection() {
  return (
    <section id="trending" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">
            Trending Categories
          </h2>
          <p className="text-sm text-foreground-500">
            Most popular spreadsheet categories updated for 2026
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {trendingCategories.map((cat, idx) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} category`}
                  title={`${cat.name} - Hipobuy Spreadsheet Category`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-1 text-center">
                  {cat.name}
                </h3>
                <p className="text-xs text-accent-600 font-medium text-center mb-3">{cat.update}</p>
                <div className="flex justify-center mb-3">
                  <span className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-colors whitespace-nowrap ${
                    idx === 0
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'bg-transparent text-foreground-700 border-2 border-foreground-200 hover:border-foreground-400'
                  }`}>
                    View {cat.name}
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </span>
                </div>
                <p className="text-xs text-foreground-400 text-center">{cat.itemCount}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}